import {
    sendFeedbackDialogTitle,
    sendFeedbackEmailSubject,
    sendFeedbackEmailContentStart,
} from './createSendFeedbackCallback.locstring.json';
import loc from 'owa-localize';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { displayNewMessageForm } from '../adapters/ReadAdapters/DisplayNewMessageFormAdapter';

export default function sendFeedbackCallback(): void {
    const recipients: EmailAddressWrapper[] = [
        {
            Name: loc(sendFeedbackDialogTitle),
            EmailAddress: 'outlookinclientstorefeedback@service.microsoft.com',
        },
    ];
    displayNewMessageForm(
        recipients,
        [],
        [],
        loc(sendFeedbackEmailSubject),
        loc(sendFeedbackEmailContentStart),
        []
    );
}
